<div class="container py-5 text-center">
    <h2>Descarga la aplicación</h2>
    <p>
        <a href="https://play.google.com/store/apps/details?id=com.wescotcorp.sospect"
            class="btn btn-primary m-2">Google Play</a>
        <a href="javascript:void(0)" class="btn btn-secondary m-2 disabled">App Store (Próximamente)</a>
    </p>
</div>